import {ioJsonFetchAction} from 'Core/store/actions/io';
import {isSuccessful} from 'Core/helpers/io';
import * as itemFilterDataMap from './dataMap/filter';
import * as listItemDataMap from './dataMap/listItem';
import {get} from 'lodash';
import {getArray} from 'Core/helpers/data';
import {hideLoading, showDialogLoading} from 'Core/helpers/loading';
import {reducerStoreKey} from './reducer';
import {actionCreators} from "Core/store/reducers";

/**
 * Fetch eFax log list
 *
 * @param {function} [abortCallback=(abortController)=>{}] - Callback function that will receive AbortController as an
 * argument.
 * @param {Object} [filter] - Fetch filter.
 * @param {number} [pageNo] - Current page number to load (pagination). Starts from 1.
 * @param {number} [perPage] - Number of items per page to load (pagination). Used system default if not specified.
 * @param {string} [sortBy] - Sort field name. The API defines sort fields.
 * @param {SortOrder} [sortDir] - Sort direction.
 * @return {function(*=): Promise<IoJsonFetchResponseObject>}
 */
export const fetchEFaxLogListAction = (
	abortCallback, filter = null, pageNo = 1, perPage, sortBy, sortDir
) => dispatch => {
	return ioJsonFetchAction(
		abortCallback,
		'defaultAuthorizedApi',
		'study/search-efax-message',
		'',
		filter,
		null,
		pageNo,
		perPage,
		sortBy,
		sortDir
	)(dispatch)
		// Get mapped data from response data
		.then(responseData => {
			if (isSuccessful(responseData)) {
				return ({
					...responseData,
					filter: itemFilterDataMap.input(get(responseData, 'filter')),
					data: getArray(responseData, 'data').map(i => listItemDataMap.input(i))
				});
			}
			return undefined;
		});
};

/**
 * Load eFax log list into Redux store
 *
 * @param {function} [abortCallback=(abortController)=>{}] - Callback function that will receive AbortController as an
 * argument.
 * @param {Object} [filter] - Fetch filter.
 * @param {number} [pageNo] - Current page number to load (pagination). Starts from 1.
 * @param {number} [perPage] - Number of items per page to load (pagination). Used system default if not specified.
 * @param {string} [sortBy] - Sort field name. The API defines sort fields.
 * @param {SortOrder} [sortDir] - Sort direction.
 * @return {function(*=): Promise<IoJsonFetchResponseObject>}
 */
export const loadEFaxLogListAction = (
	abortCallback, filter = null, pageNo = 1, perPage, sortBy, sortDir
) => dispatch => {
	const loading = showDialogLoading('e-fax-log-dialog');
	return fetchEFaxLogListAction(abortCallback, filter, pageNo, perPage, sortBy, sortDir)(dispatch)
		// Load data into Redux store
		.then(responseData => {
			if (responseData) dispatch(actionCreators[reducerStoreKey].setEFaxLogListData(responseData));
			hideLoading(loading);
			return responseData;
		});
};

/**
 * Clear eFax log list from the Redux store
 *
 * @return {(function(*): void)|*}
 */
export const clearEFaxLogListAction = () => dispatch => {
	dispatch(actionCreators[reducerStoreKey].clearEFaxLogListData());
}